import styled, { css } from "styled-components";

import { easingSeconds } from "core/animation";
import { bold as boldStyles } from "core/fontStyles";
import fonts from "core/fonts";
import colors from "core/colors";

const Link = styled.a`
    text-decoration: underline;
`;

const textStyles = css`
    ${({ size }) =>
        size === "inherit" ? "font-size: inherit" : fonts.typeScale[size]};
    ${({ bold }) => (bold ? boldStyles : null)};
    color: ${({ color }) => (color ? color : "inherit")};
`;

const A = styled.a`
    ${textStyles};
    text-decoration: underline;
`;

/* use for text that looks like a link,
but doesn't actually take the user to a new page */
const ButtonLink = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    ${textStyles};
    text-decoration: underline;
`;

/* use for an anchor tag that has a border-bottom instead of an underline;
    style is exported in case we need to add it to a link.
    Exported the hover because we need only the hover state for some links
*/
export const BorderBottomLinkStylesDefault = css`
    color: ${colors.fossil};
    text-decoration: none;
    padding-bottom: 0.1875rem; /* 3px */
    border-bottom: 1px solid ${colors.fossil};
    transition: all ${easingSeconds};
`;

export const BorderBottomLinkStylesHover = css`
    text-decoration: none;
    color: ${colors.ink};
    border-bottom: 1px solid ${colors.ink};
`;

export const BorderBottomLinkStyle = css`
    ${BorderBottomLinkStylesDefault}
    &:hover {
        ${BorderBottomLinkStylesHover}
    }
`;

export const BorderBottomLink = styled.a`
    ${BorderBottomLinkStyle}
`;

const P = styled.p`
    ${textStyles};
`;

// use headings.js instead of these headings - we will deprecate these:
const H1 = styled.h1`
    ${textStyles};
`;

const H2 = styled.h2`
    ${textStyles};
`;

const H3 = styled.h3`
    ${textStyles};
`;

const CustomFocusStyle = css`
    &:focus {
        outline: 3px solid ${colors.focus};
    }
`;

export { Link, A, P, H1, H2, H3, ButtonLink, CustomFocusStyle };
